import React from 'react';
import bemHelper from 'react-bem-helper';
import './styles.scss';

import socialShareAnalytics from '../../analytics/social-share';
import { linkUrl } from '../../../storefront/utils';
import Facebook from '../../../../subComponents/share-facebook-button';
import Twitter from '../../../../subComponents/share-twitter-button';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-social' });

class SocialShareModule extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      storefrontUrl: ''
    };
  }

  componentDidMount() {
    this.setState({
      storefrontUrl: location.href
    });
  }

  render() {
    const { partnerName } = this.props;

    return (
      <div {...bem()}>
        <h3 {...bem('subtitle')}>Like this partner?</h3>
        <div {...bem('links')}>
          <span {...bem('share')}>Share it on</span>
          <div onClick={socialShareAnalytics.registryFacebook}>
            <Facebook
              linkUrl={linkUrl(this.state.storefrontUrl)}/>
          </div>
          <div onClick={socialShareAnalytics.registryTwitter}>
            <Twitter
              text={partnerName}
              linkUrl={linkUrl(this.state.storefrontUrl)}/>
          </div>
        </div>
      </div>
    );
  }
}

SocialShareModule.propTypes = {};

export default SocialShareModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/SocialShareSection/SocialShare.js